import React, { forwardRef } from 'react'
import { Dialog, DialogContent, Grow } from '@mui/material'
import RiskAssessment from 'components/modals/RiskAssessment'
import { motion } from 'framer-motion'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function RiskAssessmentQuizModal({ onClose }) {
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'md'}
      PaperProps={{
        sx: {
          overflow: { xs: 'auto', sm: 'visible' },
          margin: '16px',
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="risk-intro"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <RiskAssessment closeModal={onClose} />
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
